var _g, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardimage6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_109_64162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 274,
    height: 274,
    rx: 30,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.18 139.834L138.46 138.781C137.13 138.637 136.006 137.763 135.495 136.527C135.489 136.512 135.483 136.497 135.477 136.483C134.965 135.247 135.141 133.834 135.98 132.792L142.108 125.175C143.264 123.739 143.152 121.663 141.848 120.359L130.376 108.887C129.072 107.584 126.997 107.472 125.56 108.627L117.94 114.758C116.901 115.595 115.491 115.772 114.258 115.264C114.244 115.259 114.231 115.254 114.217 115.248C112.977 114.739 112.099 113.613 111.955 112.279L110.902 102.555C110.704 100.723 109.157 99.3341 107.313 99.3341H91.0888C89.2454 99.3341 87.6983 100.723 87.5 102.555L86.447 112.279C86.3028 113.612 85.4247 114.739 84.1844 115.248C84.1709 115.254 84.1574 115.259 84.1442 115.264C82.9105 115.773 81.5014 115.595 80.4619 114.758L72.841 108.627C71.4049 107.472 69.3289 107.584 68.0258 108.887L56.5534 120.359C55.2499 121.663 55.1378 123.739 56.2934 125.175L62.422 132.792C63.2606 133.834 63.437 135.247 62.9245 136.483C62.9183 136.497 62.9125 136.512 62.9063 136.527C62.3953 137.763 61.2711 138.637 59.9413 138.781L50.2214 139.834C48.3886 140.032 47 141.579 47 143.423V159.647C47 161.49 48.3886 163.037 50.2214 163.236L59.9409 164.288C61.2708 164.432 62.3953 165.306 62.9059 166.542C62.9121 166.557 62.918 166.572 62.9242 166.586C63.4366 167.822 63.2602 169.235 62.4216 170.277L56.293 177.894C55.1374 179.33 55.2495 181.406 56.553 182.71L68.0254 194.182C69.3289 195.486 71.4049 195.598 72.841 194.442L80.4612 188.311C81.5007 187.474 82.9097 187.297 84.1435 187.805C84.157 187.81 84.1705 187.816 84.184 187.821C85.4244 188.331 86.302 189.457 86.4463 190.79L87.4993 200.514C87.6976 202.347 89.2447 203.735 91.088 203.735H107.312C109.156 203.735 110.703 202.347 110.901 200.514L111.954 190.79C112.098 189.457 112.976 188.331 114.216 187.821C114.23 187.816 114.243 187.81 114.257 187.805C115.49 187.297 116.899 187.474 117.939 188.311L125.559 194.442C126.996 195.598 129.072 195.486 130.375 194.182L141.847 182.71C143.151 181.406 143.263 179.33 142.107 177.894L135.979 170.277C135.14 169.235 134.964 167.822 135.476 166.586C135.482 166.572 135.488 166.557 135.495 166.542C136.006 165.306 137.13 164.432 138.46 164.288L148.179 163.236C150.012 163.037 151.4 161.49 151.4 159.647V143.423C151.401 141.579 150.013 140.032 148.18 139.834ZM99.2006 167.809C90.2126 167.809 82.9262 160.523 82.9262 151.535C82.9262 142.547 90.2126 135.26 99.2006 135.26C108.189 135.26 115.475 142.547 115.475 151.535C115.475 160.523 108.189 167.809 99.2006 167.809Z",
    fill: "#E5594F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.344 123.566L225.672 118.297C224.609 117.458 224.019 116.171 224.018 114.816C224.018 114.802 224.018 114.788 224.018 114.773C224.016 113.416 224.607 112.126 225.672 111.284L232.344 106.015C233.872 104.808 234.413 102.733 233.668 100.934L230.737 93.8584C229.992 92.0592 228.142 90.9745 226.209 91.2017L217.765 92.1936C216.416 92.3521 215.086 91.8576 214.128 90.8959C214.118 90.8857 214.108 90.8755 214.098 90.8656C213.14 89.9073 212.648 88.58 212.806 87.2349L213.798 78.791C214.025 76.8575 212.94 75.0079 211.141 74.2629L204.065 71.3322C202.267 70.5872 200.192 71.1277 198.985 72.6555L193.715 79.3275C192.876 80.3907 191.589 80.9806 190.235 80.9813C190.22 80.9813 190.206 80.9813 190.192 80.9813C188.834 80.9835 187.544 80.3929 186.703 79.3275L181.433 72.6551C180.227 71.127 178.151 70.5864 176.353 71.3315L169.277 74.2625C167.478 75.0076 166.393 76.8571 166.62 78.791L167.612 87.2352C167.77 88.5833 167.276 89.9131 166.314 90.8715C166.304 90.8817 166.294 90.8919 166.283 90.9022C165.325 91.8598 163.998 92.3521 162.653 92.194L154.209 91.202C152.275 90.9748 150.426 92.0599 149.681 93.8587L146.75 100.935C146.005 102.734 146.545 104.809 148.073 106.016L154.745 111.285C155.809 112.124 156.398 113.411 156.399 114.765C156.399 114.78 156.399 114.794 156.399 114.809C156.402 116.166 155.811 117.456 154.745 118.297L148.073 123.567C146.545 124.774 146.004 126.848 146.75 128.647L149.68 135.723C150.425 137.522 152.275 138.607 154.209 138.38L162.653 137.388C164.001 137.229 165.331 137.724 166.289 138.686C166.3 138.696 166.309 138.706 166.32 138.716C167.277 139.674 167.77 141.001 167.611 142.347L166.619 150.791C166.392 152.725 167.477 154.574 169.276 155.319L176.352 158.25C178.151 158.995 180.226 158.455 181.433 156.926L186.702 150.254C187.542 149.191 188.828 148.601 190.183 148.601C190.197 148.601 190.211 148.601 190.226 148.601C191.583 148.598 192.874 149.189 193.715 150.254L198.984 156.927C200.191 158.455 202.266 158.996 204.065 158.25L211.141 155.319C212.94 154.574 214.025 152.725 213.798 150.791L212.806 142.347C212.647 140.999 213.142 139.669 214.103 138.711C214.114 138.701 214.124 138.69 214.134 138.681C215.093 137.723 216.419 137.231 217.765 137.389L226.209 138.381C228.143 138.608 229.992 137.523 230.737 135.724L233.668 128.648C234.413 126.848 233.872 124.773 232.344 123.566ZM194.535 127.397C187.748 130.209 179.966 126.985 177.154 120.198C174.343 113.41 177.566 105.628 184.354 102.817C191.141 100.005 198.923 103.228 201.734 110.016C204.546 116.804 201.323 124.586 194.535 127.397Z",
    fill: "#F39A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_109_64162",
    x: -19,
    y: -19,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_64162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_109_64162",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -23,
    dy: -19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_109_64162"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0 0.443137 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_109_64162",
    result: "effect3_innerShadow_109_64162"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardimage6);
export default __webpack_public_path__ + "static/media/cardimage6.13cc3c825cca81b66db1f68c413e845d.svg";
export { ForwardRef as ReactComponent };